import React, { useState, useEffect } from 'react';
import { PhoneCall, Mail, MapPin, Menu, X, MessageCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { siteData } from '../data/siteData';
import QuoteModal from '../components/QuoteModalNew';
import { Link, NavLink } from 'react-router-dom';

const C = { accent: '#FD3DB5', accentLight: '#ff6bc9', bg: '#0b0b0f', card: '#121218', muted: '#1a1a22' };
const serif = { fontFamily: "'Cormorant Garamond', Georgia, serif" };

const SITE = 'https://toplesswaitressingmelbourne.com.au';

export const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'Female Strippers', to: '/female-strippers' },
  { label: 'Lingerie Models', to: '/lingerie-models' },
  { label: 'Poker Packages', to: '/poker-packages' },
  { label: 'Cruise Packages', to: '/cruise-packages' },
];

const setTag = (selector, create, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) { el = document.createElement(create.tag); Object.entries(create.attrs).forEach(([k, v]) => el.setAttribute(k, v)); document.head.appendChild(el); }
  el.setAttribute(attr, value);
};

export const setSeo = ({ title, description, path }) => {
  if (title) { document.title = title; setTag('meta[property="og:title"]', { tag: 'meta', attrs: { property: 'og:title' } }, 'content', title); }
  if (description) {
    setTag('meta[name="description"]', { tag: 'meta', attrs: { name: 'description' } }, 'content', description);
    setTag('meta[property="og:description"]', { tag: 'meta', attrs: { property: 'og:description' } }, 'content', description);
  }
  setTag('link[rel="canonical"]', { tag: 'link', attrs: { rel: 'canonical' } }, 'href', `${SITE}${path || window.location.pathname}`);
};

export const NavLinks = ({ className, onClick, testPrefix }) => navLinks.map(l => (
  <NavLink key={l.to} to={l.to} end onClick={onClick} data-testid={`${testPrefix}-${l.label.toLowerCase().replace(/ /g, '-')}`}
    className={({ isActive }) => `${className} whitespace-nowrap transition-colors ${isActive && !l.to.includes('#') ? 'text-[#FD3DB5]' : 'text-gray-400 hover:text-white'}`}>{l.label}</NavLink>
));

const WA_URL = 'https://wa.me/61428909900';
const WaIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor" aria-hidden="true"><path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35zM12.05 21.5h-.01a9.43 9.43 0 0 1-4.8-1.31l-.35-.21-3.57.94.95-3.48-.23-.36a9.4 9.4 0 0 1-1.44-5.02c0-5.2 4.24-9.44 9.46-9.44 2.52 0 4.9.99 6.68 2.77a9.38 9.38 0 0 1 2.76 6.68c0 5.21-4.24 9.44-9.45 9.44zm8.04-17.48A11.3 11.3 0 0 0 12.05.7C5.78.7.68 5.8.68 12.06c0 2 .52 3.96 1.52 5.68L.58 23.3l5.7-1.5a11.33 11.33 0 0 0 5.77 1.47c6.27 0 11.37-5.1 11.37-11.36 0-3.04-1.18-5.89-3.33-8.04z"/></svg>
);

export const HeaderWhatsApp = () => (
  <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="hidden md:inline-flex items-center gap-2 h-9 px-4 rounded-md text-xs font-semibold text-white bg-[#25D366] hover:bg-[#1ebe5b] transition-colors whitespace-nowrap" data-testid="header-whatsapp-btn">
    <WaIcon />WhatsApp
  </a>
);

export const MobileWhatsApp = () => (
  <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="flex w-full items-center justify-center gap-2 h-10 rounded-md text-sm font-semibold text-white bg-[#25D366] hover:bg-[#1ebe5b] transition-colors" data-testid="mobile-whatsapp-btn">
    <WaIcon />WhatsApp Us
  </a>
);

const PageLayout = ({ children, pageTitle, metaDescription, path }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showFloat, setShowFloat] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const d = siteData;

  useEffect(() => {
    setSeo({ title: pageTitle, description: metaDescription, path });
    window.scrollTo(0, 0);
  }, [pageTitle, metaDescription, path]);

  useEffect(() => {
    const h = () => setShowFloat(window.scrollY > 400);
    window.addEventListener('scroll', h);
    return () => window.removeEventListener('scroll', h);
  }, []);

  return (
    <div className="min-h-screen" style={{ background: C.bg, fontFamily: "'Inter', system-ui, sans-serif" }}>
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md border-b" style={{ background: `${C.bg}ee`, borderColor: `${C.accent}15` }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-[72px]">
          <Link to="/" className="flex items-center gap-2" data-testid="header-logo">
            <span className="text-2xl font-bold" style={{ ...serif, color: C.accent }}>TW</span>
            <div className="hidden sm:block lg:hidden xl:block">
              <span className="text-sm font-semibold text-white leading-tight tracking-wide">{d.business.name}</span>
              <p className="text-[10px] tracking-[0.2em] uppercase" style={{ color: `${C.accent}99` }}>{d.business.tagline}</p>
            </div>
          </Link>
          <nav className="hidden lg:flex items-center gap-5 xl:gap-7" data-testid="desktop-nav">
            <NavLinks testPrefix="nav" className="text-[11px] tracking-[0.12em] uppercase font-medium" />
          </nav>
          <div className="flex items-center gap-3">
            <HeaderWhatsApp />
            <Button size="sm" className="hidden md:flex text-white text-xs font-semibold px-5 h-9" style={{ background: C.accent }} onClick={() => setIsModalOpen(true)} data-testid="header-cta">Book Now</Button>
            <button className="lg:hidden text-white p-2" data-testid="mobile-menu-toggle" onClick={() => setMobileMenu(!mobileMenu)}>
              {mobileMenu ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
        {mobileMenu && (
          <div className="lg:hidden border-t px-4 py-4 space-y-3" style={{ background: C.bg, borderColor: 'rgba(255,255,255,0.05)' }}>
            <NavLinks testPrefix="mobile-nav" className="block text-sm py-2" onClick={() => setMobileMenu(false)} />
            <MobileWhatsApp />
            <Button className="w-full text-white text-sm font-semibold h-10 mt-2" style={{ background: C.accent }} onClick={() => { setIsModalOpen(true); setMobileMenu(false); }}>Book Now</Button>
          </div>
        )}
      </header>

      {/* Page Content */}
      {typeof children === 'function' ? children({ C, serif, setIsModalOpen, d }) : children}

      {/* Footer */}
      <footer className="py-16" style={{ background: C.card, borderTop: '1px solid rgba(255,255,255,0.04)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="text-xl font-bold" style={{ ...serif, color: C.accent }}>TW</span>
                <span className="text-white font-semibold text-sm">{d.business.name}</span>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed">Melbourne's most trusted entertainment agency. Over 10 years delivering unforgettable events.</p>
            </div>
            <div>
              <h4 className="text-[10px] uppercase tracking-[0.2em] text-gray-400 font-semibold mb-4">Pages</h4>
              <ul className="space-y-2 text-sm text-gray-500">
                {navLinks.map(l => <li key={l.to}><Link to={l.to} className="hover:text-white transition-colors">{l.label}</Link></li>)}
              </ul>
            </div>
            <div>
              <h4 className="text-[10px] uppercase tracking-[0.2em] text-gray-400 font-semibold mb-4">Services</h4>
              <ul className="space-y-2 text-sm text-gray-500">
                {['Topless Waitressing', 'Strip Shows', 'Poker Dealers', 'Bucks Packages', 'Boat Cruises'].map(s => <li key={s}>{s}</li>)}
              </ul>
            </div>
            <div>
              <h4 className="text-[10px] uppercase tracking-[0.2em] text-gray-400 font-semibold mb-4">Contact</h4>
              <ul className="space-y-2 text-sm text-gray-500">
                <li>{d.business.phone}</li><li>{d.business.email}</li><li>{d.business.location}</li>
              </ul>
            </div>
          </div>
          <div className="border-t pt-8 text-center text-xs text-gray-600" style={{ borderColor: 'rgba(255,255,255,0.05)' }}>
            &copy; {new Date().getFullYear()} {d.business.name}. All rights reserved.
          </div>
        </div>
      </footer>

      {/* Floating CTA */}
      <div className={`fixed bottom-6 left-6 z-50 transition-all duration-500 ${showFloat ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'}`}>
        <Button className="text-white font-semibold px-6 h-12 rounded-full shadow-xl text-sm" style={{ background: C.accent, boxShadow: `0 8px 30px ${C.accent}40` }} onClick={() => setIsModalOpen(true)}>
          <PhoneCall className="w-4 h-4 mr-2" />Book Now
        </Button>
      </div>

      {/* WhatsApp */}
      <a href="https://wa.me/61428909900" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 p-4 rounded-full bg-[#25D366] text-white shadow-lg hover:scale-110 transition-transform" aria-label="WhatsApp">
        <MessageCircle className="w-6 h-6" />
      </a>

      <QuoteModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export { PageLayout, C, serif };
export default PageLayout;
